<template>
    <v-list-item>
        <v-list-item-avatar>
            <v-avatar v-if="trainer == null" color="grey" style="opacity: 0.5"></v-avatar>
            <v-avatar v-else :color="trainer.color" v-text="(trainer.first_name[0] + trainer.last_name[0]).toUpperCase()"/>
        </v-list-item-avatar>
        <v-list-item-content>
            <v-list-item-title v-if="trainer == null"><span class="text--disabled">None</span></v-list-item-title>
            <template v-else>
                <v-list-item-title v-text="trainer.first_name + ' ' + trainer.last_name"/>
                <v-list-item-subtitle v-text="trainer.email" style="user-select: text !important"/>
            </template>
        </v-list-item-content>
        <v-dialog v-model="trainer_select" max-width="350" persistent>
            <template v-slot:activator="{ on }">
            <v-list-item-action><v-btn icon v-on="on" :disabled="false && disabled"><v-icon>more_vert</v-icon></v-btn></v-list-item-action>
            </template>
            <v-card>
                <v-toolbar dark color="primary" flat height="48">
                    <v-icon left @click="trainer_select = false">arrow_back</v-icon>
                    <v-spacer></v-spacer><v-btn text @click="set_trainer(selected_trainer)">Change</v-btn>
                </v-toolbar>
                <v-card-text class="pb-0">
                    <v-autocomplete
                      :allow-overflow="false"
                      auto-select-first
                      hide-selected
                      :items="$store.getters['teacher/trainers']"
                      v-model="selected_trainer"
                      autofocus
                      append-icon=""
                      prepend-inner-icon="search"
                      :item-text="i => i.first_name + ' ' + i.last_name"
                      return-object
                      placeholder="None"
                      clearable
                      class="mt-5">
                        <!-- <template v-slot:selection="{ item }">
                            <v-avatar :color="item.color" size="30" left>{{item.last_name.length != 0 ? (item.first_name[0] + item.last_name[0]).toUpperCase() : '?'}}</v-avatar><div style="width: 10pt"/>{{ item.first_name }} {{ item.last_name }}<div style="width: 6pt"/>
                        </template>
                        <template v-slot:item="{ item }">
                            <v-avatar :color="item.color" size="30" left>{{item.last_name.length != 0 ? (item.first_name[0] + item.last_name[0]).toUpperCase() : '?'}}</v-avatar><div style="width: 10pt"/>{{ item.first_name }} {{ item.last_name }}
                        </template> -->
                    </v-autocomplete>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar app v-model="snackbar">
            <v-icon left>error</v-icon>
            {{ snackbar_msg }}
        </v-snackbar>
    </v-list-item>
</template>

<script>

export default {
    name: 'TrainerPicker',
    props: {
        disabled: Boolean,
        student: Object,
        secondary: Boolean,
    },
    data () {
        return {
            selected_trainer: null,
            trainer_select: false,
            snackbar_msg: '',
            snackbar: false
        }
    },
    watch: {
        student: {
            handler (newVal, oldVal) { // eslint-disable-line no-unused-vars
                this.selected_trainer = this.trainer;
            },
            deep: true
        }
    },
    computed: {
        trainer () {
            var student = this.$store.getters['teacher/students'].find(s => s.id == this.student.id);
            if (this.secondary) {
                return student.secondary_trainer;
            } else {
                return student.trainer;
            }
        }
    },
    methods: {
        async set_trainer (trainer) {
            try {
                await this.$store.dispatch(
                    'teacher/put_trainer',
                    {
                        student: this.student,
                        trainer: trainer,
                        secondary: this.secondary
                    }
                );
                this.trainer_select = false;
            } catch (e) {
                this.snackbar_msg = 'Error setting trainer';
                this.snackbar = true;
            }
        }
    },
    async mounted () {
        if (this.$store.getters['teacher/trainers'].length == 0) {
            await this.$store.dispatch('teacher/get_trainers');
        }
    }
}

</script>
